import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownComponent} from './dropdown.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatTooltipModule} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";



@NgModule({
    declarations: [DropdownComponent],
    exports: [
        DropdownComponent
    ],
    imports: [
        CommonModule,
        MatDividerModule,
        MatTooltipModule,
        TranslateModule,
    ]
})
export class DropdownModule { }
